import {
  jb_facts_css_default
} from "./chunk.WHZOU3UB.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.TC6HXM2Y.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  awaitForEach,
  isPartiallyInViewPort
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r2 as r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-facts/jb-facts.ts
var JbFacts = class extends Spaceable(i) {
  constructor() {
    super(...arguments);
    this.headlineStyle = "h2";
    this._scrollHandler = () => {
      this._fadeInIfInViewport(this);
    };
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.enableFadeIn) {
      document.addEventListener("scroll", this._scrollHandler, true);
    }
  }
  disconnectedCallback() {
    document.removeEventListener("scroll", this._scrollHandler, true);
    super.disconnectedCallback();
  }
  firstUpdated() {
    if (this.enableFadeIn) {
      setTimeout(() => {
        this._fadeInIfInViewport(this);
      }, 0);
    } else {
      this._skipFadeIn();
    }
  }
  _fadeInIfInViewport(element) {
    if (isPartiallyInViewPort(element, 250)) {
      this._startFadeInAnimation().then(() => {
        document.removeEventListener("scroll", this._scrollHandler, true);
      });
    }
  }
  _getCols() {
    if (this.intranetStyle) {
      return this.columns <= 2 ? this.columns : 2;
    }
    return this.columns;
  }
  _getContentSpacingProperties() {
    const cols = { 1: 8, 2: 8, 3: 10 }[this._getCols()] || 8;
    const align = "center";
    const type = "focus";
    return { align, colsMdUp: cols, type, grid: true };
  }
  _headlineRank() {
    return this.headlineStyle === "h3" ? 3 : 2;
  }
  _headlineVariant() {
    return this.headlineStyle === "h3" ? "heading-md" : "heading-lg";
  }
  _skipFadeIn() {
    this._facts.forEach((fact) => {
      fact.classList.add("show");
    });
  }
  async _startFadeInAnimation() {
    setTimeout(async () => {
      await awaitForEach(this._facts, async (fact) => {
        fact.classList.add("show");
        await new Promise((p) => setTimeout(p, 50));
      });
    }, 0);
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "facts"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <section
        class=${e({
      ["cols-" + this._getCols()]: true
    })}
        part="facts"
      >
        ${this.headline ? b`<header>
                <jb-heading
                  rank=${this._headlineRank()}
                  variant=${this._headlineVariant()}
                  >${this.headline}</jb-heading
                >
              </header>` : A}
        <jb-heading-context rank=${this.headline ? this._headlineRank() + 1 : A}>
          <div class="container">
            ${this.items.map(
      (item) => b`
                <div class="fact">
                  <div class="content">
                    <jb-heading class="title">${item.title}</jb-heading>
                    <jb-heading-context offset="1">
                      <jb-richtext
                        @jb-link:clicked=${this._tracking}
                        size="small"
                        >${o(item.content)}</jb-richtext
                      >
                    </jb-heading-context>
                  </div>
                </div>
              `
    )}
          </div>
        </jb-heading-context>
      </section>
    `;
  }
};
JbFacts.styles = [reset_css_default, jb_facts_css_default];
__decorateClass([
  n({ type: Number })
], JbFacts.prototype, "columns", 2);
__decorateClass([
  n({ type: Boolean })
], JbFacts.prototype, "enableFadeIn", 2);
__decorateClass([
  n({ reflect: true })
], JbFacts.prototype, "headline", 2);
__decorateClass([
  n({ reflect: true })
], JbFacts.prototype, "headlineStyle", 2);
__decorateClass([
  n({ type: Boolean })
], JbFacts.prototype, "intranetStyle", 2);
__decorateClass([
  n({ type: Array })
], JbFacts.prototype, "items", 2);
__decorateClass([
  r(".fact")
], JbFacts.prototype, "_facts", 2);
JbFacts = __decorateClass([
  customElement("jb-facts")
], JbFacts);

export {
  JbFacts
};
